<script setup lang="ts">
useHead({
  // as a string,
  // where `%s` is replaced with the title
  titleTemplate: '%s - SecuCheck',
})
</script>

<template>
  <div class="min-h-[100dvh] min-w-full">
    <NuxtLayout>
      <div className="w-full h-full">
        <NuxtLoadingIndicator color="var(--color-primary-500)" />
        <NuxtPage />
      </div>
    </NuxtLayout>
  </div>
</template>
